export default __webpack_public_path__ + "static/virsat-page-opt3-c44d0aa778514f3b5ac50607d770fef6.gif";